import {
  Alert,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

interface ConfirmUserSuspensionDialogProps {
  email: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmUserSuspensionDialog = ({
  email,
  onConfirm,
  onCancel,
}: ConfirmUserSuspensionDialogProps) => {
  return (
    <>
      <DialogTitle>Suspend User From Workspace</DialogTitle>
      <Divider light />
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2">
            Are you sure you want to suspend{' '}
            <Box component="span" fontWeight="700">
              {email}
            </Box>{' '}
            from your workspace?
          </Typography>
          <Alert severity="info">
            Once the user is suspended, all their saved artifacts &
            subscriptions will still be retained. For any changes, please reach
            out to Enterpret team via Slack/email.
          </Alert>
        </Stack>
      </DialogContent>
      <Divider light />
      <DialogActions sx={{ my: 1, mx: 2 }}>
        <Button
          autoFocus
          variant="contained"
          color="primary"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button autoFocus variant="outlined" color="error" onClick={onConfirm}>
          Suspend User
        </Button>
      </DialogActions>
    </>
  );
};
